import type { TBankInfo } from '@shared/types/user';
import type { FC } from 'react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { ExpandMore } from '@mui/icons-material';
import { Box } from '@mui/material';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@src/design-system/collapsible';

const BankInfoCollapse: FC<{ bank_account: TBankInfo | null }> = ({
  bank_account,
}) => {
  const [open, setOpen] = useState(true);

  return (
    <Box
      className='w-full border border-primary-200 rounded-lg py-3 px-3 mt-4'
      sx={{ bgcolor: '#fdfdfe' }}
    >
      <Collapsible
        open={open}
        onOpenChange={setOpen}
      >
        <CollapsibleTrigger asChild>
          <button className='flex items-center justify-between w-full text-lg font-semibold'>
            <p className='text-gray-800 text-base font-medium flex items-center gap-1'>
              Bank Information
            </p>
            <motion.div
              animate={{ rotate: open ? 180 : 0 }}
              transition={{ duration: 0.3 }}
            >
              <ExpandMore className='w-6 h-6' />
            </motion.div>
          </button>
        </CollapsibleTrigger>

        <CollapsibleContent className='overflow-hidden mt-4'>
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: open ? 1 : 0, height: open ? 'auto' : 0 }}
            transition={{ duration: 0.3 }}
          >
            <p className='text-gray-600 text-sm mb-1'>Employment Info</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bank_account?.bank_name || '-'}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Account Holder Name</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bank_account?.account_name || '-'}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Account Number</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bank_account?.account_number || '-'}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Routing Number/IBAN</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bank_account?.iban || '-'}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Bank Address</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bank_account?.bank_address || '-'}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Swift</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bank_account?.swift_code || '-'}
            </p>

            <p className='text-gray-600 text-sm mb-1'>Currency</p>
            <p className='text-gray-800 font-medium text-sm mb-3'>
              {bank_account?.currency || '-'}
            </p>
          </motion.div>
        </CollapsibleContent>
      </Collapsible>
    </Box>
  );
};

export default BankInfoCollapse;
